(function(){
  function cleanPath(path){
    var value=(path||'/').replace(/^\/(fr|en)(?=\/|$)/i,'');
    value=value.replace(/\/+$/,'');
    return value||'/';
  }

  function localePrefix(path){
    var match=(path||'').match(/^\/(fr|en)(?=\/|$)/i);
    return match?'/'+match[1].toLowerCase():'';
  }

  function isEnglish(){
    return /^en(?:-|$)/i.test(document.documentElement.lang||'');
  }

  function navKey(path){
    var p=cleanPath(path).toLowerCase();
    if(p==='/') return 'home';
    if(p.indexOf('/products/sculpture-made-to-order')===0) return 'preorder';
    if(p.indexOf('/collections/accessoires')===0) return 'accessories';
    if(p.indexOf('/pages/lootbox')===0||p.indexOf('/pages/packs')===0) return 'packs';
    if(p.indexOf('/collections/textiles')===0) return 'merch';
    if(p.indexOf('/pages/contact')===0) return 'universe';
    if(p.indexOf('/pages/armurerie')===0||p.indexOf('/collections/svhaine-armory')===0) return 'sculptures';
    if(p.indexOf('/products/')===0){
      if(/t-shirt|tshirt|shirt|tee|hoodie|sweat|apparel/.test(p)) return 'merch';
      return 'sculptures';
    }
    return '';
  }

  function ensureNavigationStyle(){
    if(document.getElementById('sv-accessories-nav-style')) return;
    var style=document.createElement('style');
    style.id='sv-accessories-nav-style';
    style.textContent='.svhaine-nav a.sv-nav-current,.svhaine-drawer__nav a.sv-nav-current{color:var(--accent-yellow,#ffd700)!important;}';
    document.head.appendChild(style);
  }

  function injectAccessoriesNavigation(){
    var href=localePrefix(window.location.pathname)+'/collections/accessoires';
    var label=isEnglish()?'ACCESSORIES':'ACCESSOIRES';
    var navs=document.querySelectorAll('.svhaine-nav,.svhaine-drawer__nav');

    navs.forEach(function(nav){
      var links=Array.prototype.slice.call(nav.querySelectorAll('a[href]'));
      var existing=links.find(function(link){
        try{return navKey(new URL(link.href,window.location.origin).pathname)==='accessories';}
        catch(_){return false;}
      });

      if(existing){
        existing.textContent=label;
        return;
      }

      var packLink=links.find(function(link){
        try{return navKey(new URL(link.href,window.location.origin).pathname)==='packs';}
        catch(_){return false;}
      });
      if(!packLink||!packLink.parentNode) return;

      var accessoryLink=packLink.cloneNode(false);
      accessoryLink.href=href;
      accessoryLink.textContent=label;
      accessoryLink.classList.remove('sv-nav-current','active');
      accessoryLink.removeAttribute('aria-current');
      packLink.parentNode.insertBefore(accessoryLink,packLink);
    });
  }

  function reorderNavigation(){
    var desiredOrder=['home','sculptures','merch','accessories','packs','universe','preorder'];
    var navs=document.querySelectorAll('.svhaine-nav,.svhaine-drawer__nav');

    navs.forEach(function(nav){
      var links=Array.prototype.slice.call(nav.querySelectorAll(':scope > a[href]'));
      if(!links.length) links=Array.prototype.slice.call(nav.querySelectorAll('a[href]'));

      var byKey={};
      links.forEach(function(link){
        try{
          var key=navKey(new URL(link.href,window.location.origin).pathname);
          if(key&&!byKey[key]) byKey[key]=link;
        }catch(_){}
      });

      desiredOrder.forEach(function(key){
        var link=byKey[key];
        if(link&&link.parentNode===nav) nav.appendChild(link);
      });
    });
  }

  function markCurrentNavigation(){
    var current=navKey(window.location.pathname);
    if(!current) return;
    var links=document.querySelectorAll('.svhaine-nav a[href],.svhaine-drawer__nav a[href]');

    links.forEach(function(link){
      var target='';
      try{target=navKey(new URL(link.href,window.location.origin).pathname);}
      catch(_){return;}

      var active=target===current;
      link.classList.toggle('sv-nav-current',active);
      if(link.closest('.svhaine-nav')) link.classList.toggle('active',active);

      if(active) link.setAttribute('aria-current','page');
      else if(link.getAttribute('aria-current')==='page') link.removeAttribute('aria-current');
    });
  }

  function refreshNavigation(){
    ensureNavigationStyle();
    injectAccessoriesNavigation();
    reorderNavigation();
    markCurrentNavigation();
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',refreshNavigation);
  else refreshNavigation();

  document.addEventListener('shopify:section:load',refreshNavigation);
})();

/* ACCESSOIRES — fiche produit : pas de certificat d'authenticité */
(function(){
  function currentProductHandle(){
    var path=(window.location.pathname||'').replace(/^\/(fr|en)(?=\/|$)/i,'');
    var match=path.match(/\/products\/([^\/?#]+)/i);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function applyAccessoryProductRules(){
    document.querySelectorAll('.svp-stat').forEach(function(row){
      var key=row.querySelector('.svp-stat-k');
      if(!key) return;
      var text=(key.textContent||'').trim().toUpperCase();
      if(text==='CERTIFICAT'||text==='CERTIFICATE') row.remove();
    });

    var reassure=document.querySelector('.sv-reassure');
    if(reassure){
      reassure.textContent=isEnglishPage()
        ? '✓ Handmade   ·   ✓ Tracked shipping   ·   ✓ Secure payment'
        : '✓ Fait main   ·   ✓ Livraison suivie   ·   ✓ Paiement sécurisé';
    }
  }

  function isEnglishPage(){
    return /^en(?:-|$)/i.test(document.documentElement.lang||'');
  }

  function fixAccessoryProduct(){
    var handle=currentProductHandle();
    if(!handle) return;

    fetch('/collections/accessoires/products.json?limit=250',{credentials:'same-origin'})
      .then(function(response){
        if(!response.ok) throw new Error('Unable to read accessories collection');
        return response.json();
      })
      .then(function(data){
        var products=(data&&data.products)||[];
        var isAccessory=products.some(function(product){
          return product&&product.handle===handle;
        });
        if(!isAccessory) return;

        document.documentElement.classList.add('sv-accessory-product');
        applyAccessoryProductRules();
        setTimeout(applyAccessoryProductRules,150);
        setTimeout(applyAccessoryProductRules,700);
      })
      .catch(function(){});
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',fixAccessoryProduct);
  else fixAccessoryProduct();

  document.addEventListener('shopify:section:load',fixAccessoryProduct);
})();
